import { habitStore } from '../store/habitStore';

// Note: In a real environment, we'd import from '@capacitor/core' 
// and the specific health plugins. For now, we'll architect the bridge.

export const HealthSyncManager = {
    async isAvailable() {
        // Check if running in a native context and if plugins are available
        return window.Capacitor && window.Capacitor.isNativePlatform();
    },

    async requestPermissions() {
        if (!await this.isAvailable()) return false;
        // Placeholder for plugin permission request
        console.log('Requesting Health permissions...');
        return true;
    },

    async syncAll() {
        if (!await this.isAvailable()) return;

        const habits = await habitStore.getAllHabits();
        const automatedHabits = habits.filter(h => h.integration_id && !h.is_deleted);

        for (const habit of automatedHabits) {
            await this.syncHabit(habit);
        }
    },

    async syncHabit(habit) {
        if (!habit.integration_id) return;

        const dateStr = new Date().toISOString().split('T')[0];
        let value = 0;

        try {
            if (habit.integration_id === 'steps') {
                value = await this.fetchSteps(dateStr);
            } else if (habit.integration_id === 'distance') {
                value = await this.fetchDistance(dateStr);
            }

            if (value !== undefined) {
                const isCompleted = habit.direction === 'decrease'
                    ? value <= habit.goal
                    : value >= habit.goal;

                await habitStore.updateLog(habit.id, dateStr, value, isCompleted);
            }
        } catch (error) {
            console.error(`Failed to sync habit ${habit.title}:`, error);
        }
    },

    async fetchSteps(date) {
        // Placeholder for Capacitor Health Plugin call
        // const result = await HealthConnect.readRecords({ ... });
        console.log(`Fetching steps for ${date}`);
        return Math.floor(Math.random() * 10000); // Mock data for now
    },

    async fetchDistance(date) {
        console.log(`Fetching distance for ${date}`);
        return parseFloat((Math.random() * 10).toFixed(2)); // Mock data
    }
};
